import _ from 'underscore';

import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IListWithTokenFetcher } from '~src/httpClient/fetchers/IListWithTokenFetcher';
import { ListResultWithToken } from '~src/httpClient/fetchers/ListResultWithToken';
import { WebClientListWithTokenResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListWithTokenResourceFetcher';
import { ResourceQueryWithPagingToken } from '~src/httpClient/resources/ResourceQueryWithPagingToken';
import { IPagedItemsWithTokenParams } from '~src/httpClient/serverApi/types/IPageWithToken';
import { SiteAuthenticationSettingsService } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ISiteUserInfo } from '~src/userManagement/users/models/ISiteUserInfo';
import { GetSiteUsersWithTokenRequest } from '~src/userManagement/users/serverApi/requests/GetSiteUsersWithTokenRequest';


function fetchList(params: IPagedItemsWithTokenParams): Promise<ListResultWithToken<ISiteUserInfo>> {
  let listFetcher: IListWithTokenFetcher<ISiteUserInfo> = new WebClientListWithTokenResourceFetcher(GetSiteUsersWithTokenRequest, ServerApiMapper.siteUsersWithToken);

  if (!SiteAuthenticationSettingsService.isEnabled()) {
    return listFetcher.fetchList(params);
  }
  return Promise.all([
    listFetcher.fetchList(params),
    SiteAuthenticationSettingsService.getAuthSettingToProviderIdMap()])
  .then((results: any[]) => {
    const userList: ListResultWithToken<ISiteUserInfo> = results[0];
    const map: _.Dictionary<string> = results[1];

    _.each(userList.items, (siteUser: ISiteUserInfo) => {
      siteUser.authenticationProviderId = map[siteUser.authSetting];
    });
    return userList;
  });
}

export const AuthenticationProviderIdFetcherForGetSiteUsersToken = {fetchList};

class SiteUsersWithToken extends ResourceQueryWithPagingToken<ISiteUserInfo> {
  public static readonly instance = new SiteUsersWithToken(AuthenticationProviderIdFetcherForGetSiteUsersToken);
}

export const SiteUsersWithTokenResource = SiteUsersWithToken.instance;
